module.exports = __webpack_public_path__ + "static/media/appStore.ef42f284.png";